<template>
  <v-container fluid>
    <v-card-actions class="d-flex justify-end">
      <v-btn @click.prevent="$store.dispatch('vaultCart/prevStep')">
        Go back
      </v-btn>
      <v-btn @click.prevent="next"
             color="primary"
             :disabled="!canContinue">
        Continue
      </v-btn>
    </v-card-actions>

    <v-row>
      <v-col cols="12"
             sm="3">
        <v-form @submit.prevent="findDocument"
                :disabled="form.busy || docForm.busy">
          <v-card class="mb-4">
            <v-card-title class="mb-0">
              <v-icon left>
                fal fa-search
              </v-icon>
              Search
            </v-card-title>
            <v-card-text class="pb-0">
              <v-text-field v-model.number="docForm.document_number"
                            label="Document Number"
                            placeholder=""
                            outlined
                            dense
                            clearable
                            @click:clear="submit"
                            :error-messages="docForm.errors.get('document_number')">
              </v-text-field>

              <div class="mb-4">
                OR
              </div>

              <v-text-field v-model.trim="docForm.name"
                            label="Name starts with"
                            placeholder=""
                            outlined
                            dense
                            clearable
                            @click:clear="submit"
                            :error-messages="docForm.errors.get('name')"
                            class="pt-1">
              </v-text-field>
            </v-card-text>
            <v-card-actions class="px-4">
              <v-btn color="primary"
                     :disabled="form.busy || docForm.busy"
                     type="submit">
                Find
              </v-btn>
              <v-btn @click.prevent="submit"
                     :disabled="form.busy || docForm.busy">
                Reset
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>

        <cart-document-list>
        </cart-document-list>
      </v-col>
      <v-col cols="12"
             sm="9">

        <div v-if="!form.busy"
             class="d-flex justify-center my-4">
          <div v-if="results && meta && results.length">
            Showing {{ results.length | number }} of {{ meta.total | number }}
          </div>
          <div v-else-if="meta">
            No results
          </div>
        </div>

        <template v-if="results.length">

          <v-card>
            <div class="pa-4">
              <div>
                <div class="d-flex">
                  <v-spacer></v-spacer>
                  <v-switch v-model="form.importAll"
                            label="Import all"
                            @change="toggleImportAll">
                  </v-switch>
                </div>
              </div>
              <div v-if="form.importAll">
                <v-alert type="info">
                  The {{ meta.total }} {{ meta.total | pluralize('document', false) }} currently matching this filter, and all future documents matching this filter will be imported into Mobile Locker automatically.
                </v-alert>
              </div>
              <template v-else
                        v-for="document in results">
                <document-row :connection="connection"
                              :document="document"
                              :key="document.id"
                              :show-images="showImages"
                              :show-version="showVersion"
                              class="my-2">
                </document-row>
                <v-divider></v-divider>
              </template>
            </div>
          </v-card>

        </template>

        <div class="d-flex justify-center my-4"
             v-if="results.length">
          Showing {{ results.length | number }} of {{ meta.total | number }}
        </div>
        <div class="d-flex justify-center my-4"
             v-intersect="onBottomVisible">
          <v-progress-circular v-if="form.busy"
                               indeterminate
                               color="primary"
                               class="bottom">
          </v-progress-circular>
        </div>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import DocumentRow from '../components/DocumentRow';
import base64url from 'base64-url';
import {forOwn, uniqBy} from 'lodash';
import VaultImportStepper from './components/Stepper';
import formValidation from '../../../plugins/formValidation';
import CartDocumentList from './components/CartDocumentList';

export default {
  name: 'vault-import-documents',
  components: {CartDocumentList, VaultImportStepper, DocumentRow},
  mixins: [formValidation],
  data() {
    return {
      error: null,
      showImages: true,
      showVersion: true,
      docForm: new Form({
        connection: null,
        document_number: null,
        name: null,
      }),
      form: new Form({
        connection: null,
        importAll: false, // MLD-2686
        pageoffset: 0,
        pagesize: 50,
        sort: 'version_modified_date__v desc',
      }),
      pageSizes: [
        10,
        25,
        50,
        100,
        500
      ],
      sortOptions: [
        {id: 'document_creation_date__v desc', name: 'Creation Date (Newest First)'},
        {id: 'document_creation_date__v asc', name: 'Creation Date (Oldest First)'},
        {id: 'name__v asc', name: 'Document Name (A-Z)'},
        {id: 'name__v desc', name: 'Document Name (Z-A)'},
        {id: 'document_number__v asc', name: 'Document Number (A-Z)'},
        {id: 'document_number__v desc', name: 'Document Number (A-Z)'},
        {id: 'version_modified_date__v desc', name: 'Modified Date (Newest First)'},
        {id: 'version_modified_date__v asc', name: 'Modified Date (Oldest First)'},
      ],
      meta: {},
      results: [],
    }
  },
  computed: {
    ...mapGetters('veevaVault', [
      'connections',
    ]),
    ...mapGetters('vaultCart', [
      'connection',
      'documents',
      'importAll', // MLD-2686
      'step',
    ]),
    canContinue() { // MLD-2686
      return this.form.importAll || this.documents.length > 0;
    }
  },
  created() {
    this.docForm.connection = this.connection;
    this.form.importall = this.importAll;
    this.form.connection = this.connection;
    this.submit();
  },
  methods: {
    initFromQuery() {
      try {
        const q = this.$route.query.q;
        if (q) {
          const query = JSON.parse(base64url.decode(q));
          forOwn(query, (value, key) => {
            if (this.form.hasOwnProperty(key)) {
              this.form[key] = value;
            }
          })
        }
      } catch (e) {
      }
    },
    onBottomVisible(entries) {
      if (!this.meta.next_page) {
        return;
      }
      if (this.meta.size !== this.meta.pagesize) {
        return;
      }
      // More information about these options
      // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      const isBottomVisible = entries[0].isIntersecting;
      if (isBottomVisible && !this.form.busy) {
        this.search(this.meta.pageoffset + this.meta.pagesize);
      }
    },
    submit() {
      if (this.form.busy) {
        return;
      }
      this.docForm.document_number = null;
      this.docForm.name = null;
      this.resetForm();
      this.search(this.form.pageoffset);
    },
    resetForm() {
      this.results = [];
      this.form.pageoffset = 0;
      this.form.pagesize = 100;
    },
    search(offset = 0) {
      if (this.form.busy) {
        return;
      }
      this.error = null;
      const form = this.form.data();
      form.pageoffset = offset;
      const encodedQuery = base64url.encode(JSON.stringify(form));
      const nonce = Date.now().toString();
      this.$router.push({name: this.$route.name, query: {q: encodedQuery, nonce: nonce}})

      this.form.post(`/api/veeva/vault/query`, {data: form})
        .then(response => {
          this.meta = response.data.responseDetails;
          this.form.pageoffset = this.meta.pageoffset;
          this.results = uniqBy(this.results.concat(response.data.data), 'id');
        })
        .catch(err => {
          if (err.response) {
            this.error = err.response.data.message;
          }
        })
    },
    toggleImportAll() {
      this.$store.dispatch('vaultCart/setImportAll', this.form.importAll);
    },
    previous() {
      this.$store.dispatch('vaultCart/prevStep');
    },
    next() {
      this.$store.dispatch('vaultCart/nextStep');
    },
    findDocument() {
      if (!this.docForm.document_number
        && !this.docForm.name) {
        return;
      }
      // MLD-3213
      if (this.docForm.document_number) {
        // Find the specific document with the
        this.docForm.post(`/api/veeva/vault/documents/find/${this.docForm.document_number}`)
          .then(response => {
            this.meta = {
              pageoffset: 0,
              pagesize: 1,
              size: 1,
              total: 1,
            };
            this.results = [response.data];
          })
          .catch(err => {
            this.meta = {
              pageoffset: 0,
              pagesize: 1,
              size: 0,
              total: 0,
            }
            this.results = [];
          })
      } else {
        //this.results = [];
        this.docForm.post(`/api/veeva/vault/documents/find`)
          .then(response => {
            this.meta = response.data.responseDetails;
            this.results = response.data.data;
          })
          .catch(err => {

          })
      }
    },
  }
}
</script>
